import React, {FC, Fragment, useState} from 'react'
import { Button } from 'antd';
import { EyeOutlined, CloseOutlined } from '@ant-design/icons';
import {DateTimeUtils} from "@/utils";
import { useTranslation } from "react-i18next";

const NotificationDropdownItem: FC<any> = props => {
    const { notificationItem, handleMarkAsReadItem, handleDeleteItem } = props;
    const [hovering, setHovering] = useState(false);
    const { t, i18n } = useTranslation();
    return (
        <Fragment>
            <div
                className={`notification-item ${hovering ? 'notification-item-hover' : ''} ${notificationItem.read_at ? 'notification-item-read' : ''}`}
                onMouseEnter={() => setHovering(true)}
                onMouseLeave={() => setHovering(false)}
            >
                <div className="notification-item-top">
                    <a href={notificationItem.message_url ?? '#'} className={`d-block ${notificationItem.read_at ? 'text-muted' : 'text-dark'}`}>
                        {notificationItem.subject ? <h4 className={`fw-bold ${notificationItem.read_at ? 'text-muted' : 'text-dark'}`} style={{ lineHeight: '18px' }}>{notificationItem.subject}</h4> : null}
                        <div style={{ lineHeight: '18px' }}>{notificationItem.body}</div>
                    </a>
                </div>
                <div className="notification-item-bottom">
                    <div className="notification-item-action">
                        <time
                            dateTime={notificationItem.created_at}
                            title={notificationItem.created_at}
                            className="time text-muted"
                        >
                            {DateTimeUtils.timeAgo(notificationItem.created_at)}
                        </time>
                        {hovering && (
                            <span className="btn-group">
                                {!notificationItem.read_at && (
                                    <Button type="link" onClick={(event) => handleMarkAsReadItem(notificationItem.id)} className="btn-mark-as-read" icon={<EyeOutlined />}>
                                        {t("Mark as read")}
                                    </Button>
                                )}
                            </span>
                        )}
                    </div>
                </div>
            </div>
        </Fragment>
    );
}
export default React.memo(NotificationDropdownItem);